import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CookieConsentService } from '../../../core/services/cookie-consent.service';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-cookie-consent-banner',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule, ButtonComponent],
  template: `
    @if (!consent.hasChoice()) {
      <div
        class="fixed inset-x-0 bottom-0 z-[9500] p-3 sm:p-4 pointer-events-none"
        role="dialog"
        aria-live="polite"
        [attr.aria-label]="'COOKIE_CONSENT.ARIA' | translate"
      >
        <div
          class="pointer-events-auto mx-auto flex max-w-4xl flex-col gap-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-[0_-8px_32px_rgba(15,23,42,0.12)] sm:flex-row sm:items-center sm:gap-6 sm:p-5"
        >
          <div class="min-w-0 flex-1 space-y-1.5">
            <p class="text-sm font-black tracking-tight text-gray-900">
              {{ 'COOKIE_CONSENT.TITLE' | translate }}
            </p>
            <p class="text-xs font-medium leading-relaxed text-gray-500">
              {{ 'COOKIE_CONSENT.DESC' | translate }}
              <a
                routerLink="/privacy"
                fragment="privacy-6"
                class="font-bold text-primary underline-offset-2 hover:underline"
              >
                {{ 'COOKIE_CONSENT.LEARN_MORE' | translate }}
              </a>
            </p>
          </div>
          <div class="flex shrink-0 flex-col gap-2 sm:flex-row sm:items-center">
            <app-button
              type="button"
              variant="secondary"
              size="sm"
              rounded="xl"
              (click)="consent.acceptEssential()"
            >
              {{ 'COOKIE_CONSENT.ESSENTIAL' | translate }}
            </app-button>
            <app-button
              type="button"
              variant="primary"
              size="sm"
              rounded="xl"
              (click)="consent.acceptAll()"
            >
              {{ 'COOKIE_CONSENT.ACCEPT' | translate }}
            </app-button>
          </div>
        </div>
      </div>
    }
  `,
})
export class CookieConsentBannerComponent {
  readonly consent = inject(CookieConsentService);
}
